export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  author: string;
  publishedAt: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '明星爆料', slug: 'mingxing', icon: 'ri-star-line', description: '娱乐圈明星最新爆料与黑料' },
  { name: '网红黑料', slug: 'wanghong', icon: 'ri-live-line', description: '网红圈塌房翻车事件汇集' },
  { name: '社会热点', slug: 'shehui', icon: 'ri-fire-line', description: '社会热点事件深度爆料' },
  { name: '娱乐圈', slug: 'yule', icon: 'ri-movie-line', description: '影视综艺娱乐八卦全知道' },
  { name: '电竞圈', slug: 'dianjing', icon: 'ri-gamepad-line', description: '电竞圈选手与赛事内幕' },
  { name: '每日大赛', slug: 'daily', icon: 'ri-trophy-line', description: '每日吃瓜大赛热门投稿' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店共度八小时引热议',
    excerpt: '据爆料，某当红顶流男星近日被拍到深夜与一名神秘女子在某五星级酒店共度八小时，引发网友热议。该男星此前一直以单身人设示人，此次被拍或将对形象造成重大影响。',
    content: `<p>近日，知名狗仔团队拍到一段令人震惊的视频。画面中，一位近期热度正高的顶流男星深夜驱车前往某五星级酒店，随后一名身着黑色长裙的神秘女子现身，两人一前一后进入酒店电梯。</p><p>据拍摄者描述，两人在酒店内停留了约八个小时，直到次日清晨才先后离开。期间该男星全程戴着口罩和帽子，但标志性的身形和走姿还是被眼尖的网友认了出来。</p><p>消息传出后，粉丝群体迅速分化。一部分粉丝表示"只要哥哥不违法就行"，另一部分则感到失望，认为此前经营的单身人设崩塌。更有网友扒出该神秘女子疑似某网红主播，两人此前已有互动痕迹。</p><p>截至目前，该男星工作室尚未对此事作出回应。而该男星最新一条社交动态评论区已涌入大量留言，热度持续攀升。</p><p>业内人士分析称，如果此事属实，该男星代言的多个品牌可能会面临解约风险，预估损失或达数千万。吃瓜群众们，这瓜你们怎么看？</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20person%20walking%20into%20a%20luxury%20hotel%20lobby%20at%20night%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20soft%20bokeh%20background%2C%20high%20contrast%2C%20dramatic%20mood%2C%20editorial%20quality&width=800&height=500&seq=article-01&orientation=landscape',
    author: '吃瓜前线',
    publishedAt: '2026-08-04',
    views: 1285300,
    tags: ['顶流', '恋情', '塌房', '酒店'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '2',
    title: '千万粉丝网红直播翻车，口误暴露真实学历仅初中毕业',
    excerpt: '一位拥有千万粉丝的知名网红近日在直播中意外口误，暴露自己真实学历仅为初中毕业，与其此前宣称的"名校毕业"人设严重不符。',
    content: `<p>近日，一位坐拥千万粉丝的知名网红在直播带货过程中，被粉丝问到关于大学经历的问题时支支吾吾，随后脱口而出一句"我初中那会儿……"，瞬间引发直播间弹幕爆炸。</p><p>该网红此前在多个场合自称"某985高校毕业"，甚至在个人简介中也标注了知名院校名称。然而这次的翻车现场，让不少粉丝感到被欺骗。</p><p>有网友迅速扒出其早年资料，发现该网红确实只有初中学历，早年曾在工厂打工，后来靠短视频平台走红。学历造假一事曝光后，该网红的社交账号一夜之间掉粉超过50万。</p><p>事后该网红发布道歉视频，称"当时是为了让内容更有说服力才那么说的"，但这样的解释显然没能平息众怒。品牌方也纷纷与其解约，损失惨重。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20streamer%20in%20shock%20expression%20during%20live%20broadcast%2C%20dramatic%20lighting%2C%20studio%20setting%20with%20ring%20light%2C%20chaotic%20chat%20messages%20reflected%20on%20face%2C%20cinematic%20color%20grading%2C%20warm%20and%20cool%20contrast%2C%20editorial%20photography&width=800&height=500&seq=article-02&orientation=landscape',
    author: '打假小分队',
    publishedAt: '2026-08-03',
    views: 956200,
    tags: ['网红', '学历造假', '翻车', '直播'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '3',
    title: '某知名企业家涉嫌内幕交易被带走调查，公司股价暴跌',
    excerpt: '据知情人士透露，某知名上市公司实控人因涉嫌内幕交易、操纵市场等多项违法行为，已于近日被相关部门带走调查。',
    content: `<p>据多方信源证实，某知名上市公司实际控制人张某已于8月2日晚间被相关部门带走配合调查，涉及内幕交易、操纵证券市场等多项嫌疑。</p><p>消息传出后，该公司股价在次日开盘即暴跌超过15%，市值一夜蒸发近百亿。大量投资者涌向交易所平台维权，场面一度混乱。</p><p>据知情人士爆料，张某在过去两年间通过多个隐蔽账户操纵公司股价，配合利好消息发布进行高位套现，累计获利超过20亿元。目前其名下多处豪宅和资产已被冻结。</p><p>业内人士指出，此案或将成为近年来最大的证券市场违法案件之一，牵涉面可能远超外界想象。多名券商分析师和基金经理也被传出正在接受调查。</p><p>该事件在网络上引发热烈讨论，大量股民表示"早该查了"，而更多吃瓜群众则在等待后续更多的内幕曝光。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stock%20market%20trading%20floor%20with%20falling%20charts%20displayed%20on%20large%20screens%2C%20red%20numbers%20everywhere%2C%20tense%20atmosphere%2C%20businessmen%20looking%20worried%2C%20cinematic%20lighting%2C%20dark%20moody%20tones%2C%20editorial%20style&width=800&height=500&seq=article-03&orientation=landscape',
    author: '财经透视',
    publishedAt: '2026-08-04',
    views: 897400,
    tags: ['企业', '内幕交易', '股市', '调查'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '4',
    title: '某热门综艺录制现场发生冲突，两位常驻嘉宾大打出手',
    excerpt: '据现场工作人员爆料，某热门综艺节目最新一期录制过程中，两位常驻嘉宾因游戏环节产生争执，最终演变为肢体冲突。',
    content: `<p>据现场工作人员匿名爆料，某卫视热门综艺节目在最新一期的录制中发生了令人意外的一幕。两位常驻男嘉宾在游戏环节中因为规则争议产生口角，随后情绪失控，竟然在镜头前大打出手。</p><p>目击者称，当时录制已经进行了超过六个小时，两位嘉宾都处于疲惫状态。其中一位在游戏中被淘汰后不满判决结果，上前理论时被另一位嘉宾推搡，双方随即扭打在一起。</p><p>节目组紧急叫停录制，其他嘉宾和工作人员上前拉开两人。据透露，两位嘉宾此前就有不和传闻，这次冲突只是积怨已久的爆发。</p><p>此事发生后，节目组发布了简短声明称"将妥善处理"，但未透露具体细节。网友们则乐此不疲地分析两人过往的互动，扒出更多"恩怨史"，让这个瓜越滚越大。</p>`,
    category: '娱乐圈',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20confrontation%20scene%20on%20a%20TV%20variety%20show%20set%20with%20bright%20studio%20lights%2C%20two%20silhouettes%20facing%20off%2C%20cameras%20and%20equipment%20surrounding%2C%20tense%20dramatic%20atmosphere%2C%20cinematic%20composition%2C%20warm%20studio%20lighting&width=800&height=500&seq=article-04&orientation=landscape',
    author: '综艺前线',
    publishedAt: '2026-08-03',
    views: 756300,
    tags: ['综艺', '嘉宾', '冲突', '录制'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '5',
    title: 'LPL某战队内部矛盾曝光，上单与打野训练赛互喷后双双离队',
    excerpt: '英雄联盟LPL联赛某知名战队被曝内部矛盾严重，上单选手与打野选手在训练赛中爆发激烈争吵，两人随后双双宣布离队。',
    content: `<p>LPL夏季赛正处于白热化阶段，一则关于某战队内部的爆料却让电竞圈炸开了锅。据队内工作人员透露，该战队上单和打野选手在最近的训练赛中因为BP选择和游戏策略产生严重分歧。</p><p>争吵从语音频道蔓延到线下，两人在训练室当面对质，语言激烈。队友们试图劝架未果，教练组介入后依然无法平息矛盾。最终两人摔门而出，随后各自在社交媒体上发布了意味深长的动态。</p><p>战队管理层紧急召开会议，但目前尚未公布处理结果。有消息称，如果两人无法和解，战队可能需要在赛季中段做出人员调整，这对正处于季后赛关键期的战队来说无疑是致命打击。</p><p>粉丝们对此反应强烈，有人支持上单的说法，有人站打野这边，战队超话几乎被争吵帖刷屏。这波瓜，电竞圈的吃瓜群众表示"比比赛还精彩"。</p>`,
    category: '电竞圈',
    categorySlug: 'dianjing',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20esports%20gaming%20arena%20with%20two%20players%20arguing%20intensely%20across%20computer%20screens%2C%20colorful%20RGB%20gaming%20lights%2C%20dramatic%20tension%2C%20esports%20tournament%20stage%20setting%2C%20cinematic%20lighting%2C%20dark%20moody%20background&width=800&height=500&seq=article-05&orientation=landscape',
    author: '电竞吃瓜王',
    publishedAt: '2026-08-03',
    views: 643200,
    tags: ['LPL', '战队', '矛盾', '电竞'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '6',
    title: '每日大赛：谁能想到这个离婚声明背后藏着更大的瓜？',
    excerpt: '某明星夫妇官宣离婚后不到24小时，双方新恋情同时曝光，网友直呼"这瓜吃得猝不及防"，成为今日吃瓜大赛最热投稿。',
    content: `<p>今日份吃瓜大赛热榜第一的瓜来了！某知名明星夫妇昨日晚间同时发布离婚声明，措辞温和，称"和平分手，互相祝福"。然而不到24小时，狗仔就拍到了更劲爆的画面。</p><p>男方被拍到与一名年轻女性同进同出某高档公寓，女方则被拍到与一位圈外人士牵手逛街。时间之巧妙，让人怀疑双方早已各有所属，离婚只是"走个过场"。</p><p>更令人震惊的是，有网友发现男方的新欢疑似是女方的前助理，而女方的新欢则是一家投资公司的高管，传闻中两人在半年前就已经开始交往。</p><p>这波连环瓜让吃瓜群众们直呼"信息量太大，需要时间消化"。该事件的讨论热度在各大平台均位居榜首，#离婚声明后的24小时#话题阅读量已突破5亿。</p>`,
    category: '每日大赛',
    categorySlug: 'daily',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20split%20scene%20with%20two%20couples%20walking%20in%20opposite%20directions%2C%20urban%20night%20setting%2C%20cinematic%20lighting%2C%20warm%20and%20cold%20color%20contrast%2C%20emotional%20but%20stylish%20composition%2C%20editorial%20photography&width=800&height=500&seq=article-06&orientation=landscape',
    author: '吃瓜日报',
    publishedAt: '2026-08-04',
    views: 1452000,
    tags: ['离婚', '新欢', '明星', '每日大赛'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '7',
    title: '某女星片场耍大牌被导演当众训斥，视频流出引争议',
    excerpt: '一段某女星在片场耍大牌被导演当众训斥的视频在网络上流出，视频中该女星对工作人员态度恶劣，导演怒斥其"不敬业"。',
    content: `<p>近日，一段拍摄于某剧组片场的视频在网络上引发热议。视频中一位知名女星因为拍摄时间安排问题对工作人员大发脾气，摔剧本、摔手机，甚至用侮辱性语言辱骂场务人员。</p><p>忍无可忍的导演当场发飙，在全体剧组面前大声训斥该女星："你以为你是谁？整个剧组几百号人都在等你一个，你有什么资格耍大牌？不演就滚蛋！"</p><p>视频被在场人员偷偷录下并流出后，迅速登上热搜。网友们几乎一边倒地支持导演，谴责该女星的行为。多位圈内人士也发声表示"演艺圈不需要这种不尊重人的演员"。</p><p>该女星工作室随后发布道歉声明，但被网友指"敷衍了事"。目前该剧组已宣布更换女主角，该女星的多个代言品牌也受到了影响。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20a%20director%20pointing%20angrily%20at%20an%20actress%2C%20film%20crew%20watching%20in%20shock%2C%20bright%20film%20lights%2C%20professional%20camera%20equipment%2C%20dramatic%20tense%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-07&orientation=landscape',
    author: '剧组观察员',
    publishedAt: '2026-08-02',
    views: 882100,
    tags: ['耍大牌', '片场', '导演', '女星'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '8',
    title: '某电商带货主播涉嫌虚假宣传被罚千万，直播间已被封禁',
    excerpt: '一位月带货额过亿的头部电商主播因涉嫌虚假宣传保健品功效，被市场监管部门罚款1200万元，其直播间已被平台永久封禁。',
    content: `<p>据市场监管部门通报，某知名电商带货主播因在其直播间内虚假宣传某保健品具有"治疗疾病"的功效，被处以1200万元罚款，并责令停止违法行为。该主播的直播间已被平台方永久封禁。</p><p>调查显示，该主播在直播中声称某款普通保健品能够"降血压、降血糖、治疗失眠"，并使用"医学认证""专家推荐"等虚假表述误导消费者。实际上该产品仅为普通食品，不具备任何治疗功效。</p><p>此次处罚被认为是直播带货行业有史以来最严厉的惩戒措施之一。市场监管部门表示，将持续加大对直播带货领域的监管力度，保护消费者合法权益。</p><p>该主播此前以"良心带货"人设走红，拥有一千五百万粉丝。事件曝光后，大量消费者要求退款，该主播社交账号评论区沦陷。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20livestreaming%20sales%20studio%20with%20products%20scattered%20on%20table%2C%20ring%20light%20and%20camera%20setup%2C%20chaotic%20scene%2C%20dramatic%20lighting%2C%20warm%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-08&orientation=landscape',
    author: '消费维权',
    publishedAt: '2026-08-01',
    views: 723400,
    tags: ['直播带货', '虚假宣传', '罚款', '保健品'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '9',
    title: '某城市地铁建设曝出偷工减料丑闻，多名官员被调查',
    excerpt: '某省会城市地铁新线路被曝存在严重偷工减料问题，混凝土强度不达标、钢筋数量不足等问题触目惊心。',
    content: `<p>近日，一条关于某省会城市地铁建设的爆料在网络上引起轩然大波。据内部举报人提供的材料显示，该地铁线路在施工过程中存在大量偷工减料行为。</p><p>举报材料中称，部分标段的混凝土实际强度远低于设计要求，钢筋使用数量也严重不足。更令人担忧的是，负责质量检测的第三方机构涉嫌出具虚假检测报告，掩盖真实问题。</p><p>事件曝光后，该市纪委监委已介入调查，多名负责项目审批和监管的官员被带走配合调查。地铁线路的后续施工已被紧急叫停，全面进行质量排查。</p><p>此事引发了公众对公共基础设施质量的广泛担忧。有市民表示："每天有几十万人乘坐地铁，如果质量有问题，后果不堪设想。"</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20underground%20subway%20construction%20tunnel%20with%20exposed%20rebar%20and%20cracks%2C%20industrial%20setting%2C%20dramatic%20moody%20lighting%2C%20safety%20concern%20atmosphere%2C%20cinematic%20composition%2C%20documentary%20photography%20style&width=800&height=500&seq=article-09&orientation=landscape',
    author: '城建观察',
    publishedAt: '2026-08-02',
    views: 601200,
    tags: ['地铁', '偷工减料', '调查', '公共安全'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '10',
    title: '某大导演新片选角黑幕曝光，投资方指定女主角引争议',
    excerpt: '据知情人透露，某知名导演筹备三年的新片选角存在暗箱操作，女主角并非通过试镜选拔，而是投资方直接指定。',
    content: `<p>一部备受期待的国产大片在选角阶段就爆出了丑闻。据剧组内部人士爆料，该片的女主角人选并非如公开宣传的那样"经过层层筛选"，而是由主要投资方直接指定。</p><p>该指定女演员此前几乎没有表演经验，却能力压多位实力派演员获得女主角。爆料人透露，该女演员与投资方负责人关系非同一般，选角面试只是"走过场"。</p><p>多位参与试镜的演员及其经纪公司在得知真相后表达了不满。一位试镜演员的经纪人直言："浪费了我们三个月的时间准备，结果发现根本不是公平竞争。"</p><p>目前该导演尚未对此事作出回应，但其社交媒体的最新动态下面已经涌入大量质疑声。该片的公信力受到了严重损害。</p>`,
    category: '娱乐圈',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20film%20audition%20room%20with%20empty%20chairs%2C%20spotlight%20on%20a%20single%20script%2C%20behind%20the%20scenes%20movie%20set%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20mysterious%20atmosphere&width=800&height=500&seq=article-10&orientation=landscape',
    author: '电影观察',
    publishedAt: '2026-08-01',
    views: 578200,
    tags: ['导演', '选角', '黑幕', '电影'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '11',
    title: '某知名电竞选手被曝涉赌，圈内多位好友被牵连调查',
    excerpt: '某知名电竞选手被爆料参与非法赌博活动，涉及金额巨大，其圈内多位好友也被牵连正在接受调查。',
    content: `<p>电竞圈再爆大瓜！据知情人士透露，一名在国际赛事中获得过冠军的知名电竞选手涉嫌参与非法线上赌博活动，涉案金额高达数百万元。</p><p>更令人震惊的是，该选手不仅自己参与赌博，还涉嫌拉拢圈内多名选手和主播一同参与，形成了一个小范围的赌博网络。目前已有至少五位电竞圈知名人士被纳入调查范围。</p><p>赛事主办方已发布公告表示将密切关注调查进展，如果指控属实，将对该选手进行终身禁赛处罚。该选手所属俱乐部也紧急发布了声明，称"正在核实相关情况"。</p><p>这一事件让无数粉丝心碎。有人在超话留言："曾经以为你是电竞圈的榜样，没想到私下是这样的。"</p>`,
    category: '电竞圈',
    categorySlug: 'dianjing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20gaming%20room%20with%20multiple%20monitors%20showing%20game%20screens%2C%20dim%20RGB%20lighting%2C%20tense%20mysterious%20atmosphere%2C%20professional%20esports%20setup%2C%20cinematic%20composition&width=800&height=500&seq=article-11&orientation=landscape',
    author: '电竞观察室',
    publishedAt: '2026-08-02',
    views: 521400,
    tags: ['电竞', '赌博', '调查', '选手'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '12',
    title: '每日大赛：明星夫妻档综艺秀恩爱被扒全是剧本',
    excerpt: '某明星夫妻在综艺节目中大秀恩爱的片段被网友逐帧分析，发现多处穿帮镜头，被指全部按照剧本表演。',
    content: `<p>今日吃瓜大赛掀起了一波"打假"热潮！某热门明星夫妻档综艺最新一期播出后，眼尖的网友发现了大量疑点。</p><p>节目中，这对夫妻展现了一系列甜蜜互动：丈夫为妻子做饭、两人一起看日落、互相写信表白等等。然而网友逐帧分析后发现，多个场景中的物品位置前后不一致、光线变化不自然、甚至妻子的表情在"感动"和"不耐烦"之间切换。</p><p>更有工作人员匿名爆料称，节目中的所有"真情流露"都是按照详细剧本执行的，甚至连两人的对话都是编剧提前写好的。这对夫妻实际上已经分居多时，参加综艺只是为了维持商业价值。</p><p>这波打假让#综艺剧本#话题登上热搜榜首，网友纷纷表示"再也不相信综艺里的爱情了"。该节目的收视率也因此受到了影响。</p>`,
    category: '每日大赛',
    categorySlug: 'daily',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20variety%20show%20set%20with%20a%20couple%20acting%20romantic%2C%20multiple%20cameras%20visible%2C%20production%20crew%20in%20background%2C%20fake%20romantic%20setting%2C%20bright%20studio%20lights%2C%20behind%20the%20scenes%20reveal&width=800&height=500&seq=article-12&orientation=landscape',
    author: '综艺打假办',
    publishedAt: '2026-08-04',
    views: 987300,
    tags: ['综艺', '剧本', '明星夫妻', '每日大赛'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '13',
    title: '知名歌手后台耍酒疯，打砸化妆间被经纪人紧急带走',
    excerpt: '某知名歌手在音乐节演出后，因不满演出效果在后台酗酒闹事，砸坏化妆间设施后经纪人不得不紧急将其带走。',
    content: `<p>一场音乐节的后台，成了这位知名歌手的"修罗场"。据现场工作人员爆料，该歌手在演出结束后回到化妆间，对自己在台上的表现极度不满，开始大量饮酒。</p><p>酒劲上来后，该歌手情绪失控，先是摔碎了化妆台上的镜子，随后又将化妆间的梳妆台推倒，化妆品、镜子碎片散落一地。工作人员试图安抚但无果，直到经纪人赶到才强行将其带离现场。</p><p>音乐节主办方事后向场地方赔偿了化妆间的损失，但对外统一口径称"歌手身体不适提前离场"。然而多位现场目击者的爆料让真相浮出水面。</p><p>该歌手此前就有多次酒后失态的传闻，这次的"化妆间事件"让不少合作方开始重新考虑与其的合作关系。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20messy%20backstage%20dressing%20room%20with%20broken%20mirror%20and%20scattered%20items%2C%20dim%20dramatic%20lighting%2C%20concert%20backstage%20atmosphere%2C%20chaotic%20scene%2C%20cinematic%20composition&width=800&height=500&seq=article-13&orientation=landscape',
    author: '音乐节前线',
    publishedAt: '2026-08-01',
    views: 445300,
    tags: ['歌手', '酗酒', '后台', '音乐节'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '14',
    title: '百万粉丝美妆博主被扒产品测评全是广告，私下从不用',
    excerpt: '一位以"真实测评"走红的美妆博主被内部人士爆料，其所有产品推荐均为付费广告，私下使用的全是国际大牌。',
    content: `<p>"良心推荐""自用款""无限回购"——这些熟悉的美妆博主话术，在一位百万粉丝博主的翻车现场中显得格外讽刺。一位自称是该博主前助理的人士在社交平台发布了长篇爆料。</p><p>爆料内容显示，该博主每一条"真实测评"背后都有品牌方的广告合同，价格从5万到50万不等。更令人震惊的是，该博主私下使用的护肤品全是顶级国际大牌，那些她口中"性价比超高"的国货产品，她碰都没碰过。</p><p>前助理还附上了该博主的私人化妆台照片，满满的都是数千元一瓶的贵妇品牌，与她视频中展示的平价产品形成鲜明对比。</p><p>事件曝光后，该博主的账户一夜之间掉粉超过30万。多位品牌方也紧急与其切割，删除了合作内容。该博主目前仍未对此事作出回应。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20vanity%20table%20filled%20with%20expensive%20skincare%20products%2C%20contrasting%20with%20cheap%20products%20in%20the%20corner%2C%20warm%20soft%20lighting%2C%20beauty%20blogger%20studio%20setup%2C%20editorial%20style&width=800&height=500&seq=article-14&orientation=landscape',
    author: '美妆打假',
    publishedAt: '2026-07-31',
    views: 412800,
    tags: ['美妆博主', '广告', '造假', '测评'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '15',
    title: '某知名互联网公司数据造假，用户量水分高达70%',
    excerpt: '一份内部审计报告显示，某知名互联网公司的用户数据严重造假，对外公布的活跃用户数中约70%为虚假数据。',
    content: `<p>一份流出的内部审计报告，揭开了一家知名互联网公司的数据黑幕。报告显示，该公司对外宣称的月活跃用户数中，约有70%为机器人账号或已流失的沉默用户。</p><p>内部人士透露，公司为了维持高估值和吸引投资，长期要求数据部门"优化"各项指标。具体做法包括：将注册但从未使用的账号计入活跃用户、将机器刷量的数据与真实数据混合统计、将其他产品的用户数据重复计算等。</p><p>该报告原本是为了下一轮融资进行的尽职调查所用，但被内部员工匿名泄露。消息传出后，已有三家投资机构宣布暂停对该公司的投资计划，公司估值面临腰斩风险。</p><p>该公司在回应中称"数据统计口径不同导致的误解"，但这样的解释难以让外界信服。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20tech%20office%20with%20multiple%20computer%20screens%20showing%20fake%20data%20charts%2C%20dark%20corporate%20atmosphere%2C%20tense%20mood%2C%20cinematic%20lighting%2C%20documentary%20style&width=800&height=500&seq=article-15&orientation=landscape',
    author: '科技观察',
    publishedAt: '2026-08-01',
    views: 389100,
    tags: ['数据造假', '互联网', '融资', '审计'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '16',
    title: '某影视公司老板潜规则女演员录音曝光，多位女星或将发声',
    excerpt: '一段据称是某影视公司老板与经纪人商讨"潜规则"安排的录音在网络上曝光，涉及多位知名女演员。',
    content: `<p>一段长达40分钟的录音近日在网络上疯狂传播。录音中，一名据称是某大型影视公司老板的中年男性与经纪人讨论如何"安排"旗下女演员与投资方"接触"，言语之露骨令人震惊。</p><p>录音中，该老板直言"想要女一号就得拿出诚意来"，并详细描述了安排女演员"应酬"的具体流程。对话中还提到了多部热门影视剧的女主角人选，暗示角色分配与"付出"直接挂钩。</p><p>录音曝光后，娱乐圈一片哗然。多位曾与该影视公司合作的女演员的社交账号下涌入大量关心和质疑的评论。有知情人士透露，多位女星正在考虑联合发声，揭露行业内幕。</p><p>行业协会已表示将对此事展开调查，该影视公司老板目前处于失联状态。</p>`,
    category: '娱乐圈',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20corporate%20office%20with%20a%20recording%20device%20on%20desk%2C%20dramatic%20shadow%20play%2C%20mysterious%20tense%20atmosphere%2C%20film%20noir%20style%2C%20cinematic%20composition&width=800&height=500&seq=article-16&orientation=landscape',
    author: '行业观察者',
    publishedAt: '2026-08-03',
    views: 1120400,
    tags: ['潜规则', '女演员', '录音', '影视公司'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '17',
    title: 'KPL某教练被曝私下收钱安排选手上场，战队成绩疑云重重',
    excerpt: '王者荣耀KPL联赛某战队教练被爆出私下收取经纪公司好处费，安排特定选手上场，影响比赛公平性。',
    content: `<p>王者荣耀KPL联赛再曝丑闻。某战队的主教练被内部人士爆料，长期收取经纪公司的"好处费"，在比赛中安排特定选手获得更多上场机会。</p><p>据爆料人提供的微信聊天记录和转账截图显示，该教练在过去两个赛季中，从某经纪公司收取了累计超过60万元的"劳务费"。作为回报，该经纪公司旗下的选手获得了远超其水平的上场时间和核心位置。</p><p>更令人担忧的是，该战队在上赛季的关键比赛中出现了多次令人费解的BP（英雄选择）和阵容安排，直接导致战队输掉了多场本应该赢下的比赛。有粉丝怀疑教练的某些安排已经不仅仅是"偏袒"，而是存在更大的利益交换。</p><p>KPL联盟已表示将对此事展开调查，如果情况属实，该教练将面临终身禁赛的处罚。</p>`,
    category: '电竞圈',
    categorySlug: 'dianjing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20pro%20gaming%20coach%20arguing%20with%20players%20on%20stage%2C%20esports%20arena%20background%2C%20dramatic%20tension%2C%20colorful%20stage%20lights%2C%20cinematic%20composition&width=800&height=500&seq=article-17&orientation=landscape',
    author: 'KPL观察',
    publishedAt: '2026-08-02',
    views: 478200,
    tags: ['KPL', '教练', '收钱', '电竞'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '18',
    title: '每日大赛：某知名品牌代言人翻车后的72小时全记录',
    excerpt: '某国际品牌新签代言人在广告发布后72小时内连曝三个黑料，品牌方连夜撤下所有物料，成为年度最快翻车代言。',
    content: `<p>这可能是品牌代言史上最快的翻车记录了！某国际知名品牌在上周五高调宣布签下一位新晋流量明星作为品牌代言人，并投入巨资进行了线上线下全渠道投放。</p><p>然而就在广告发布的72小时内，这位代言人接连曝出三个致命黑料：先是前女友发长文控诉其出轨，随后被网友扒出早期不当言论截图，最后又被拍到在公共场合随地吐痰的视频。</p><p>品牌方反应堪称"教科书式"的速度——在第三个黑料曝光后的4小时内，所有线上广告物料全部下架，门店海报全部撤下，品牌官方账号删除了所有与该代言人相关的内容。据估算，品牌方此次直接损失超过3000万元。</p><p>网友们调侃道："这代言费花得真值，买一送三，附赠三个大瓜。"该代言人则彻底从公众视野中消失了。</p>`,
    category: '每日大赛',
    categorySlug: 'daily',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20billboard%20advertisement%20being%20taken%20down%20at%20night%2C%20workers%20on%20ladders%2C%20urban%20street%20scene%2C%20dramatic%20street%20lighting%2C%20cinematic%20composition%2C%20moody%20atmosphere&width=800&height=500&seq=article-18&orientation=landscape',
    author: '品牌观察',
    publishedAt: '2026-08-04',
    views: 867500,
    tags: ['代言', '翻车', '品牌', '每日大赛'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '19',
    title: '某男星被前女友公开讨债，千万借款协议原件流出',
    excerpt: '一位自称是某当红男星前女友的女子发布长文，公开了该男星亲笔签名的千万借款协议，要求其还钱。',
    content: `<p>一场"讨债门"让一位当红男星陷入了前所未有的信任危机。一位自称与该男星有过三年恋情的女子在社交平台发布了长达三千字的长文，详细描述了两人从相识相爱到最终因钱反目的全过程。</p><p>长文中附带了多张带有该男星亲笔签名的借款协议照片，累计金额高达1200万元。据该女子描述，这些钱是她陆续借给该男星的，用于其早期的事业投资和生活开销。</p><p>分手后，该男星不仅拒绝还款，还拉黑了她所有联系方式。该女子表示多次尝试私下沟通未果后才选择公开此事。目前借条和聊天记录的证据链相当完整，法律界人士认为如果证据属实，该男星将面临严重的法律后果。</p><p>该男星工作室目前保持沉默，只有其粉丝在超话中不断刷屏"相信哥哥"。但这个瓜，恐怕没那么容易消化。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20with%20papers%20and%20contracts%20scattered%20on%20a%20table%2C%20a%20pen%20and%20signature%20visible%2C%20warm%20but%20tense%20lighting%2C%20legal%20document%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-19&orientation=landscape',
    author: '感情纠纷线',
    publishedAt: '2026-08-03',
    views: 912300,
    tags: ['借钱', '前任', '协议', '讨债'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '20',
    title: '某美食博主吃播"假吃"被实锤，剪辑师受不了良心谴责爆料',
    excerpt: '一位自称是某千万粉丝美食博主剪辑师的人发布视频，揭露该博主所有"大胃王"视频都是靠剪辑和后期做出来的。',
    content: `<p>吃播界最大的骗局终于被自己人揭穿了！一位自称曾为某千万粉丝美食博主工作两年的视频剪辑师，在离职后发布了一条长达20分钟的爆料视频。</p><p>视频中详细展示了该博主"吃播"视频的造假全过程：所谓的"一口气吃完十斤小龙虾"实际上分了三顿饭拍摄、用替身的手部特写来制造"狂吃"假象、大量食物最终被吐进了桌子下面的垃圾桶。该剪辑师表示是"实在受不了良心上的谴责"才选择公开。</p><p>爆料视频中甚至展示了原片与成片的对比，造假痕迹一目了然。该博主此前以"真实""不浪费食物"为卖点获得了大量粉丝的信任和打赏，如今这一切瞬间崩塌。</p><p>视频发布后，平台方已对该博主的账号进行了限制处理。大量曾经打赏过的粉丝要求退款，场面一度混乱。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20video%20editing%20studio%20with%20multiple%20screens%20showing%20food%20footage%2C%20timeline%20editing%20software%20visible%2C%20exposed%20secrets%20atmosphere%2C%20dark%20moody%20lighting%2C%20documentary%20style&width=800&height=500&seq=article-20&orientation=landscape',
    author: '吃播打假',
    publishedAt: '2026-07-30',
    views: 567800,
    tags: ['吃播', '假吃', '剪辑', '美食博主'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '21',
    title: '某地高考舞弊案细节曝光，幕后主使竟是教育局干部',
    excerpt: '一起发生在某地的高考舞弊案近日细节曝光，调查发现幕后主使竟是该地教育局的一名科长级干部。',
    content: `<p>一起高考舞弊案的最新调查结果令人震惊。据专案组透露，在某地查处的一起涉及37名考生的高考舞弊案中，幕后主使竟是该地教育局招生办的一名科长。</p><p>调查显示，该科长利用职务之便，通过修改考生信息、调配监考人员、安排特殊考场等手段，帮助特定考生在高考中获取不当优势。每名考生的"服务费"从20万到80万不等，该科长两年间累计获利超过1000万。</p><p>更令人愤怒的是，这些通过舞弊获取高分的考生，挤占的是其他寒窗苦读十二年学生的名额。案件曝光后，涉及的37名考生的成绩已经被宣布无效，相关的录取结果也将被撤销。</p><p>该科长目前已被依法刑事拘留，案件正在进一步深挖中。教育公平是底线，触碰底线的代价必须让所有人都看到。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20classroom%20with%20exam%20papers%20scattered%2C%20a%20single%20desk%20illuminated%2C%20dramatic%20serious%20atmosphere%2C%20education%20setting%2C%20cinematic%20composition&width=800&height=500&seq=article-21&orientation=landscape',
    author: '教育观察',
    publishedAt: '2026-07-30',
    views: 534100,
    tags: ['高考', '舞弊', '教育局', '公平'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '22',
    title: '某选秀节目黑幕大起底，冠军内定全过程被前导演曝光',
    excerpt: '一位曾参与某知名选秀节目制作的导演离职后公开发声，揭露了节目组内部操纵票数和内定冠军的全过程。',
    content: `<p>"观众看到的每一票，其实早就被安排好了。"一位曾在某知名选秀节目担任执行导演的人士，在离职后接受了媒体专访，首次公开揭露了选秀节目的造假内幕。</p><p>据该前导演透露，节目的冠军人选在节目开播前就已经由广告商和经纪公司共同确定。整个节目过程中的投票、淘汰、复活等环节，都是为了配合这个"剧本"而设计的。观众的短信投票和网络投票实际上不会影响最终结果，后台有专门的数据团队负责"调整"票数。</p><p>该导演还表示，选手们在镜头前的"真情实感"大部分都是按照编剧写的剧本表演的，甚至一些"意外冲突"也是节目组刻意安排的。真正的才艺反而成了最不重要的因素。</p><p>这则爆料让曾经为该节目狂热打投的粉丝们感到被深深欺骗。该节目目前正在播出新一季，收视率已出现明显下滑。</p>`,
    category: '娱乐圈',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20spotlight%20on%20empty%20center%2C%20judges%20table%20in%20shadow%2C%20dramatic%20behind%20the%20scenes%20revelation%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere&width=800&height=500&seq=article-22&orientation=landscape',
    author: '选秀揭黑',
    publishedAt: '2026-08-02',
    views: 798400,
    tags: ['选秀', '内定', '投票', '造假'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '23',
    title: 'DOTA2某战队假赛实锤曝光，全队被终身禁赛震动电竞圈',
    excerpt: 'DOTA2赛事组织方公布调查结果，确认某战队在关键比赛中故意输掉比赛以获取非法利益，全队5名选手被终身禁赛。',
    content: `<p>DOTA2电竞圈遭遇了有史以来最大的假赛丑闻。赛事组织方召开新闻发布会，公布了历时三个月的调查结果，确认某知名战队在去年的两场关键比赛中存在假赛行为。</p><p>调查显示，该战队在对阵弱队时故意选择不合理的阵容和战术，最终以极为反常的方式输掉比赛。背后的博彩数据显示，这两场比赛存在大量异常投注，涉及金额超过500万元。</p><p>调查还发现，该战队的五名选手及教练均参与了这一假赛计划，其中两人是组织者。赛事组织方宣布对涉事人员全部处以终身禁赛的处罚，同时取消该战队过去一年的所有成绩和奖金。</p><p>这一事件对整个电竞行业造成了巨大冲击，多个赛事组织方表示将加强对假赛的监测和处罚力度。对于热爱电竞的粉丝来说，信任的裂痕需要很长时间才能修复。</p>`,
    category: '电竞圈',
    categorySlug: 'dianjing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20esports%20arena%20with%20empty%20chairs%20and%20dim%20monitors%2C%20disappointment%20atmosphere%2C%20professional%20gaming%20setup%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=article-23&orientation=landscape',
    author: 'DOTA2前线',
    publishedAt: '2026-08-04',
    views: 612700,
    tags: ['DOTA2', '假赛', '终身禁赛', '电竞'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '24',
    title: '每日大赛：某明星离婚案开庭，财产分割细节让人瞠目结舌',
    excerpt: '某明星夫妇离婚案今日开庭审理，双方就财产分割进行激烈交锋，揭露的财产数量和种类让吃瓜群众目瞪口呆。',
    content: `<p>今日份的"富豪式"吃瓜，来自一场万众瞩目的明星离婚案。某知名演员和其配偶的离婚案今日在法院开庭审理，法庭上双方披露的财产清单简直是一部"财富百科全书"。</p><p>根据庭上公开的信息，这对夫妻名下共有23套房产、12辆豪车、5家公司股权、超过2亿元的理财产品，以及大量的珠宝首饰和艺术品收藏。双方律师在庭上就每一项财产的归属展开了激烈的辩论。</p><p>更令吃瓜群众兴奋的是，庭审中还披露了双方婚前签订的一份"忠诚协议"，如果一方出轨需赔偿对方5000万元。女方律师当庭出示了男方出轨的证据，要求按协议执行赔偿。</p><p>这场"富豪离婚案"让网友们大开眼界。有网友评论："原来明星的离婚比我中彩票还精彩。"该案将在下周继续审理。</p>`,
    category: '每日大赛',
    categorySlug: 'daily',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20courtroom%20scene%20with%20judge%20bench%20and%20lawyers%2C%20documents%20and%20papers%20everywhere%2C%20dramatic%20legal%20atmosphere%2C%20cinematic%20lighting%2C%20serious%20mood&width=800&height=500&seq=article-24&orientation=landscape',
    author: '法庭前线',
    publishedAt: '2026-08-04',
    views: 1012400,
    tags: ['离婚', '财产分割', '庭审', '每日大赛'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '25',
    title: '某流量明星被曝税务问题，补缴税款及罚款或超2亿',
    excerpt: '据税务系统人士透露，某当红流量明星因税务问题正在接受调查，可能面临超过2亿元的补缴税款和罚款。',
    content: `<p>娱乐圈的"税务风暴"又来了！据权威消息源透露，税务部门正在对一位近两年爆红的流量明星进行全面的税务稽查。初步调查结果显示，该明星存在以"阴阳合同"方式隐瞒真实收入、违规注册公司转移个人所得等多项问题。</p><p>据估算，该明星需补缴的税款加上罚款可能超过2亿元，这将是近年来单个艺人涉及金额最高的税务案件之一。该明星目前正在紧急筹措资金，试图在调查结论出来前主动补缴以争取从宽处理。</p><p>消息人士透露，税务部门已经掌握了大量证据，包括多份"阴阳合同"原件和相关银行流水。该明星的代孕风波、学历造假等问题也同时被深挖出来。</p><p>品牌方已经开始紧急评估风险，多个代言合作处于暂停状态。这波"塌房"的连锁反应还在持续发酵中。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20but%20dark%20office%20with%20tax%20documents%20and%20calculators%2C%20serious%20financial%20investigation%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=article-25&orientation=landscape',
    author: '财经娱乐',
    publishedAt: '2026-08-02',
    views: 1089300,
    tags: ['税务', '流量明星', '阴阳合同', '罚款'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: '26',
    title: '某脱口秀演员因不当言论被封杀，演出全部取消',
    excerpt: '某知名脱口秀演员在演出中发表不当言论引发争议，该演员已被行业全面封杀，全国巡演全部取消。',
    content: `<p>一句话毁掉了整个职业生涯。某知名脱口秀演员在最近一场线下演出中，为了制造"笑果"发表了严重不当的言论，触碰了公众底线。</p><p>现场有观众录下该段表演并上传至网络，视频迅速传播并引发公愤。网友普遍认为该言论已经超出了幽默的范畴，构成了对特定群体的侮辱。各大平台在24小时内全部下架了该演员的相关内容。</p><p>该演员所属的演出机构紧急发布道歉声明，宣布与其解约。原定在全国20个城市的巡回演出全部取消，票务平台开启了全面退票。据估算，仅退票金额就超过800万元。</p><p>该演员在社交平台发长文道歉，称自己"当时只想搞笑，没有恶意"，但大多数网友并不买账。在公众人物言论规范的讨论中，这个案例成了一个标志性的事件。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20empty%20comedy%20club%20stage%20with%20a%20single%20microphone%20stand%2C%20dim%20spotlight%2C%20sad%20abandoned%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=article-26&orientation=landscape',
    author: '文化观察',
    publishedAt: '2026-08-01',
    views: 678200,
    tags: ['脱口秀', '封杀', '言论', '取消'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '27',
    title: '某旅游博主被曝行程全靠编，定位造假被平台官方揭穿',
    excerpt: '一位拥有两百万粉丝的旅行博主被平台官方揭穿，其所有"环球旅行"内容均在国内拍摄，定位信息全部造假。',
    content: `<p>"今天在巴黎喝咖啡""明天在冰岛看极光"——一位旅行博主的完美人设，被平台官方的一纸公告打得粉碎。该博主被检测到所有发布内容的真实定位均在同一个国内城市。</p><p>平台安全团队在例行数据核查中发现，该博主的100多条"环球旅行"内容，实际IP地址均指向其家乡。所谓的巴黎铁塔、冰岛极光、马尔代夫海滩等场景，全部是通过绿幕抠图、使用背景素材和后期特效制作的。</p><p>该博主此前靠"环球旅行"人设获得了大量品牌合作和粉丝打赏，甚至出版了一本"旅行自传"。事件曝光后，出版社宣布停止该书的销售并接受退货。</p><p>有网友调侃道："人在家中坐，环球旅行梦——这话说的就是这位博主吧。"</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20green%20screen%20studio%20setup%20with%20fake%20travel%20backdrops%2C%20camera%20and%20lighting%20equipment%2C%20exposed%20fake%20travel%20blogger%20scene%2C%20dramatic%20lighting&width=800&height=500&seq=article-27&orientation=landscape',
    author: '旅游打假',
    publishedAt: '2026-07-29',
    views: 398500,
    tags: ['旅行博主', '造假', '定位', '绿幕'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '28',
    title: '某知名编剧被指抄袭海外作品，多部热播剧面临下架风险',
    excerpt: '一位被称为"金牌编剧"的知名编剧被网友扒出其多部热播作品涉嫌抄袭海外影视剧，部分情节几乎逐字翻译。',
    content: `<p>又一位"抄袭大师"落网了。一位曾创作过多部热播剧的知名编剧，被网友扒出其代表作与多部海外影视剧存在大量"雷同"之处。</p><p>网友们制作了详细的对比视频，显示该编剧的作品中数十场关键戏份与海外剧几乎完全一致，包括场景设计、台词节奏，甚至连运镜方式都一模一样。有网友直言："这哪是致敬，这根本就是翻译。"</p><p>事件发酵后，多家购买了该编剧作品版权的视频平台开始紧急评估风险。如果抄袭指控坐实，这些平台将面临原作品版权方的索赔，多部热播剧面临下架风险。</p><p>该编剧发表声明称"所有创作均受中外优秀作品的启发"，但这种说法无异于变相承认。编剧行业协会已表示将对此事展开调查。</p>`,
    category: '娱乐圈',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20desk%20with%20scripts%20and%20screenplays%20side%20by%20side%20showing%20similarities%2C%20dramatic%20plagiarism%20reveal%20atmosphere%2C%20dim%20study%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=article-28&orientation=landscape',
    author: '编剧观察',
    publishedAt: '2026-07-31',
    views: 534600,
    tags: ['编剧', '抄袭', '热播剧', '下架'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '29',
    title: 'Valorant某职业选手账号被盗，窃贼竟是同队队友',
    excerpt: '无畏契约（Valorant）某职业选手发现游戏账号被盗，调查后发现盗窃者竟是和他同吃同住的队友。',
    content: `<p>一个让人寒心的电竞圈内幕。Valorant（无畏契约）某职业战队的一名选手发现自己价值不菲的游戏账号被盗，账号内包含了大量限定皮肤和赛事限定道具。</p><p>该选手报警后，警方通过IP追踪锁定了嫌疑人——竟然是他的同队队友。调查显示，该队友趁其外出比赛时将账号密码记录下来，随后通过申诉方式将账号的绑定手机和邮箱全部更换。</p><p>更令人震惊的是，该队友盗号的动机并非单纯为了钱，而是因为对俱乐部首发位置的不满，企图通过这种方式"搞垮"竞争对手。这个发现让整个战队都陷入了信任危机。</p><p>俱乐部已紧急将涉事选手开除，并向警方报案。该事件在Valorant社区引发了关于职业选手职业道德的大讨论。</p>`,
    category: '电竞圈',
    categorySlug: 'dianjing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20gaming%20room%20with%20two%20desks%2C%20one%20dark%20and%20one%20lit%2C%20betrayal%20atmosphere%2C%20esports%20team%20house%20setting%2C%20dramatic%20lighting%20contrast%2C%20cinematic%20composition&width=800&height=500&seq=article-29&orientation=landscape',
    author: 'Valorant前线',
    publishedAt: '2026-07-30',
    views: 389200,
    tags: ['Valorant', '盗号', '队友', '信任'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '30',
    title: '每日大赛：某知名品牌请AI生成广告图，结果翻车成年度笑柄',
    excerpt: '某知名消费品牌为省钱使用AI生成广告图片，结果AI在图中"创作"出了匪夷所思的内容，成为全网笑柄。',
    content: `<p>今天的吃瓜大赛笑点来自一则"AI翻车"广告。某知名快消品牌在最新的线上投放中使用了一组AI生成的广告图片，结果AI在图片中"自由发挥"的部分让人哭笑不得。</p><p>在一张宣传"家庭聚餐"的广告图中，AI给画面中的小孩添加了六根手指，餐桌上的食物则是一种地球上不存在的奇异生物。另一张"户外运动"的广告图中，AI把自行车的轮子画成了方形，而背景中的人像则是五官扭曲的"克苏鲁"式存在。</p><p>这些图片被网友发现后迅速传播，#AI广告翻车#话题直接冲上热搜。品牌方紧急撤下广告并发布了幽默的自嘲声明："连AI都觉得我们的产品超乎想象。"</p><p>不过这份声明并没有完全平息负评，有消费者质疑品牌"连请个设计师都舍不得，产品能好到哪去"。这波翻车被公认为今天最好吃的瓜。</p>`,
    category: '每日大赛',
    categorySlug: 'daily',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20funny%20AI%20generated%20advertisement%20with%20obvious%20errors%2C%20distorted%20faces%20and%20objects%2C%20comedic%20failure%2C%20bright%20commercial%20lighting%2C%20satirical%20atmosphere&width=800&height=500&seq=article-30&orientation=landscape',
    author: '广告圈吃瓜',
    publishedAt: '2026-08-04',
    views: 789200,
    tags: ['AI', '广告', '翻车', '每日大赛'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '31',
    title: '某女团成员私下抽烟酗酒视频流出，清纯人设瞬间崩塌',
    excerpt: '一段某当红女团成员私下抽烟酗酒的视频在网络上流出，与其在镜头前营造的"乖乖女"形象形成巨大反差。',
    content: `<p>又一个清纯人设崩塌的例子。某当红女团中人气最高的一位成员，被曝光了一段私下聚会的视频。</p><p>视频中，该成员手持香烟吞云吐雾，动作娴熟，明显不是第一次。更让人惊讶的是，她面前摆着多种烈酒，和朋友大声划拳喝酒，言语粗俗，与舞台上乖巧甜美的形象判若两人。</p><p>该视频据称是其朋友酒后不小心发到群聊后被传播出去的。事件曝光后，不少低龄粉丝表示"滤镜碎了"，其家长群体更是反应激烈，纷纷要求其退出女团。</p><p>经纪公司火速发布声明，称该视频是"恶意剪辑和拼接"，但视频的完整程度让这个说法显得苍白无力。商业代言方面，已有两家品牌宣布暂停合作。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20private%20party%20scene%20with%20cigarettes%20and%20alcohol%20on%20table%2C%20dim%20moody%20lighting%2C%20contrast%20with%20bright%20stage%20image%20reflected%2C%20cinematic%20composition&width=800&height=500&seq=article-31&orientation=landscape',
    author: '女团观察',
    publishedAt: '2026-08-03',
    views: 701300,
    tags: ['女团', '人设崩塌', '抽烟', '反差'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '32',
    title: '某知识付费大V被扒所有内容均来自免费公开资料',
    excerpt: '一位年收入过千万的知识付费大V被学员曝光，其售价数千元的付费课程内容全部可以在网上免费获取。',
    content: `<p>"你的知识付费，不过是别人免费的搬运。"一位知识付费领域的头部大V近日遭遇了最致命的质疑——他售价2999元的"独家版权课程"，被学员发现全部内容都来自于免费的公开资料。</p><p>一位花了三千元购买课程的学员在学完后，偶然在网上搜索相关资料，竟找到了与课程内容几乎完全一致的免费文档和视频。经过仔细对比，该大V的课程内容连案例和措辞都原封不动地照搬了免费资料。</p><p>该学员将对比结果发布到网上后，更多购买过课程的人纷纷加入验证行列，结果发现该大V旗下的所有付费课程都存在类似问题。其所谓的"十年经验总结"不过是把别人的免费产出重新包装了一下。</p><p>面对汹涌的质疑，该大V关闭了评论并暂停了所有课程销售。但已经购买课程的数千名学员正在组织集体维权，要求全额退款。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20desk%20with%20laptop%20showing%20paid%20courses%20on%20one%20screen%20and%20free%20content%20on%20another%2C%20fraud%20exposure%20atmosphere%2C%20dramatic%20lighting%2C%20documentary%20style&width=800&height=500&seq=article-32&orientation=landscape',
    author: '知识打假',
    publishedAt: '2026-08-02',
    views: 456200,
    tags: ['知识付费', '抄袭', '退款', '大V'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '33',
    title: '某地方官员家族资产曝光，名下百套房产震惊全网',
    excerpt: '一份流出的财产申报材料显示，某地一位处级官员及其家庭成员名下拥有超过100套房产，来源成谜。',
    content: `<p>一份内部流出的公职人员财产申报材料，让全网吃瓜群众目瞪口呆。某地一位处级官员的家庭财产清单显示，其本人和直系亲属名下共拥有超过100套房产，分布在全国多个城市。</p><p>材料中详细列出了这些房产的地址和面积，其中不乏一线城市的豪宅和别墅。以该官员的合法收入计算，即使不吃不喝工作500年也无法积累如此巨量的财富。</p><p>举报人称，这些房产大多登记在该官员的远房亲戚和"白手套"名下，实际控制人仍为该官员本人。涉及的房产总价值初步估算超过5亿元。</p><p>目前该官员已被纪检监察部门带走调查。这起案件被视为基层反腐败的典型案例，相关调查正在深入进行中。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=Multiple%20luxury%20apartment%20buildings%20stacked%20like%20playing%20cards%2C%20dramatic%20corruption%20exposure%20concept%2C%20dark%20moody%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=article-33&orientation=landscape',
    author: '廉政观察',
    publishedAt: '2026-08-03',
    views: 845100,
    tags: ['官员', '房产', '腐败', '调查'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: '34',
    title: '某音乐节目导师被指台上台下两幅面孔，学员爆料其私下辱骂',
    excerpt: '某音乐选秀节目的一位导师在镜头前温和亲切，但多位曾经的学员爆料其私下脾气暴躁，经常辱骂学员。',
    content: `<p>镜头前的"暖心导师"和镜头后的"暴君"，竟是同一个人。多位曾经在某音乐选秀节目中接受过一位导师指导的学员，在节目结束后联合发声，揭露了这位导师的真实面目。</p><p>学员们描述，该导师在录制时总是面带微笑、语气温柔，但一旦摄像机停止录制，就完全换了一副面孔。有学员爆料自己在排练时因为一个音符没唱准，被导师当众骂"你是不是没长脑子"，还有学员被骂哭后被告知"哭完了继续练，别耽误我时间"。</p><p>一位已经退出娱乐圈的前学员说："当时不敢说是因为签了保密协议，现在觉得必须说出来，让后面的人不要再被这种人PUA。"</p><p>节目组未对此事作出回应，但该导师的社交账号评论已被网友攻陷，大量留言要求其向学员们道歉。</p>`,
    category: '娱乐圈',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20music%20studio%20with%20a%20chair%20in%20spotlight%20and%20shadows%20around%2C%20contrast%20between%20bright%20stage%20and%20dark%20backstage%2C%20dramatic%20duality%20concept%2C%20cinematic%20lighting&width=800&height=500&seq=article-34&orientation=landscape',
    author: '音乐圈观察',
    publishedAt: '2026-08-01',
    views: 543200,
    tags: ['音乐节目', '导师', '双面人', '学员爆料'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '35',
    title: 'CS2某天才选手被曝使用作弊软件，职业生涯或将终结',
    excerpt: 'CS2（反恐精英2）职业赛场上一位被誉为天才的年轻选手被赛事反作弊系统检测出使用作弊软件。',
    content: `<p>CS2职业圈的一颗新星陨落了。一位年仅18岁就在国际赛场上崭露头角的"天才选手"，被赛事官方的反作弊系统检测出在正式比赛中使用了外挂软件。</p><p>赛事组织方的调查结果显示，该选手在比赛中使用了一款精心设计的作弊程序，该程序能够在不触发常规检测的情况下提供微弱的瞄准辅助。正是这种"微作弊"方式，让他在关键对枪中总能"奇迹般"地赢下。</p><p>调查还发现，该选手从职业生涯初期就开始使用这一作弊软件，这意味着他所有的成绩和荣誉都建立在欺骗之上。赛事组织方宣布取消其所有历史成绩，并处以终身禁赛的处罚。</p><p>该选手所属俱乐部发布声明称"对此毫不知情，深感震惊和愤怒"，同时向所有粉丝和对手道歉。但无论怎样，这个"天才"的传奇故事已经彻底破灭了。</p>`,
    category: '电竞圈',
    categorySlug: 'dianjing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20professional%20gaming%20setup%20with%20warning%20signs%20on%20screen%2C%20cheating%20detection%20concept%2C%20dark%20dramatic%20gaming%20room%2C%20betrayal%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-35&orientation=landscape',
    author: 'CS2观察',
    publishedAt: '2026-07-31',
    views: 467300,
    tags: ['CS2', '作弊', '天才选手', '禁赛'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: '36',
    title: '每日大赛：一线城市天价"鸽子笼"出租屋曝光，月租3000住厕所改造',
    excerpt: '一篇关于某一线城市天价"鸽子笼"出租屋的爆料帖引发全城热议，月租3000元的房间实际是厕所改造而来。',
    content: `<p>今天的吃瓜大赛迎来了一则让人笑不出来的"硬核"爆料。一位在某一线城市打工的年轻人发布了一篇长帖，详细展示了自己月租3000元的"房间"——一间由公共厕所改造而来的狭小空间。</p><p>该房间面积不足5平方米，原先是老式居民楼的公共卫生间。房东将马桶拆除后铺了一张床垫就算"精装修"，墙上还保留着原来的瓷砖和排水管道。房客需要在楼道的公共洗手间洗漱，唯一的"优势"是离地铁站步行只需10分钟。</p><p>帖子发布后迅速引发了全城打工人的共鸣。大量网友晒出了自己租住的各种奇葩房源，从"厨房改造房"到"阳台胶囊房"，堪称一部"打工人租房血泪史"。</p><p>住建部门表示已关注到相关情况，将对违规出租行为进行排查整治。但在这个房价和租金都高企的城市，整治之后，这些年轻人又能搬去哪里？</p>`,
    category: '每日大赛',
    categorySlug: 'daily',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20tiny%20cramped%20room%20with%20old%20bathroom%20tiles%20and%20a%20mattress%20on%20floor%2C%20pipes%20visible%20on%20walls%2C%20poor%20living%20conditions%2C%20dramatic%20contrast%20with%20modern%20city%20outside%20window&width=800&height=500&seq=article-36&orientation=landscape',
    author: '城市观察',
    publishedAt: '2026-08-04',
    views: 693400,
    tags: ['租房', '一线城市', '鸽子笼', '每日大赛'],
    isHot: false,
    isFeatured: false,
  },
];

export const featuredArticles = articles.filter(a => a.isFeatured);
export const hotArticles = articles.filter(a => a.isHot);
export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter(a => a.categorySlug === slug);
}
export function getArticleById(id: string): Article | undefined {
  return articles.find(a => a.id === id);
}